import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { PageEvent } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { map, startWith } from "rxjs/operators";
import {
  RespCountries,
  RespRegions,
  RespSearch,
  RespVarietalGroups,
  VarietyFilter,
} from "../model/variedad.model";
import { VariedadService } from "../service/variedad.service";
import { UserService } from "../../user/service/user.service";
import { AuthService } from "../../auth/service/auth.service";
import { ObservationService } from "../../observation/service/observation.service";

export interface CardContent {
  card_id: number | null;
  card_id_1: number | null;
  card_name: string | null;
  card_id_2: number | null;
  card_name_2: string | null;
  card_value_1: string | null;
  card_date: string | null;
  card_value_2: string | null;
  card_user_id: number | null;
  card_username: string | null;
  card_user_image_url: string | null;
  card_image_url: string | null;
}


@Component({
  selector: "app-variedad-list-view",
  templateUrl: "./variedad-list-view.component.html",
  styleUrls: ["./variedad-list-view.component.css"],
})
export class VariedadListViewComponent implements OnInit {
  constructor(
    private variedadService: VariedadService,
    private userService: UserService,
    private router: Router,
    private authService: AuthService,
    private observationService: ObservationService,
  ) { }

  matBadgeVarietyFilters?: number | null;
  cardContentList!: CardContent[];
  variedadSubs$!: Subscription;
  page_control = 0;
  page_size_control = 20;
  _length: number | string = '---';
  _showFirstLastButtons = true;
  _pageSizeOptions: number[] = [5, 20, 40, 60, 100, 500];
  // viewType: string = "catalogo";
  // == //
  variety_control = new FormControl(null);
  country_control = new FormControl(null);
  region_control = new FormControl(null);
  varietal_group_control = new FormControl(null);
  user_control = new FormControl(null);
  // == //
  filteredOptionsVariety!: Observable<string[]>;
  filteredOptionsCountry!: Observable<RespCountries>;
  filteredOptionsRegion!: Observable<RespRegions> | boolean;
  filteredOptionsVarietalGroup!: Observable<RespVarietalGroups>;
  filteredOptionsUser!: Observable<any>;

  userList!: any[];

  observationVarietyCounts!: Observable<any>;

  ngOnInit(): void {

    this.fnVarietyCount();

    const _advanceFilters = this.variedadService.getFilters();
    if (_advanceFilters.length) {
      this.matBadgeVarietyFilters = _advanceFilters.length;
      const _var = {
        page: this.page_control,
        page_size: this.page_size_control,
        _filters: { filters: _advanceFilters },
      };
      this.fnAdvanceSearchVariety(_var);
    } else {
      this.fnSearchVariety();
    }

    this.filteredOptionsVariety = this.variety_control.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchVarietyNames(_value))
    );

    this.filteredOptionsCountry = this.variedadService.getCountries();

    this.filteredOptionsRegion = this.variedadService.getRegions("all");


    this.country_control.valueChanges.subscribe((_country: string | null) => {
      if (_country) {
        this.filteredOptionsRegion = this.variedadService.getRegions(_country);
      } else {
        this.filteredOptionsRegion = this.variedadService.getRegions("all");
        this.fnSearchVariety();
      }
    });


    this.filteredOptionsVarietalGroup = this.variedadService.getVarietalGroups();

    this.filteredOptionsUser = this.userService.getUsers();

    this.filteredOptionsUser.subscribe(
      (resp: any) => {
        this.userList = [];
        resp.data.map(
          (x: any) => {
            if ([7, 8, 9, 13, 14, 15].includes(x.user_id)) {
              this.userList.push(x);
            }
          }
        );
      }
    );
  }

  handlePageEvent(event: PageEvent) {
    this.page_control = event.pageIndex;
    this.page_size_control = event.pageSize;
    this._length = event.length;
    const _advanceFilters = this.variedadService.getFilters();
    if (_advanceFilters.length) {
      this.matBadgeVarietyFilters = _advanceFilters.length;
      const _var = {
        page: event.pageIndex,
        page_size: event.pageSize,
        _filters: { filters: _advanceFilters },
      };
      this.fnAdvanceSearchVariety(_var);
    } else {
      this.fnSearchVariety();
    }
  }

  fnSearchVariety() {
    let _user_id = null;
    if (this.user_control.value && this.user_control.value != '') {
      const _value: {
        user_id: number;
        username: any;
        first_name: any;
        last_name: any;
        image_url: string;
      } = this.user_control.value
      _user_id = _value.user_id;
    }

    const _var = {
      page: this.page_control,
      page_size: this.page_size_control,
      variety_name: this.variety_control.value,
      country: this.country_control.value,
      region: this.region_control.value,
      varietal_group: this.varietal_group_control.value,
      original_only: true,
      is_original: null,
      user_id: _user_id,
      created_date: null,
    };
    this.cardContentList = [];



    this.variedadSubs$ = this.variedadService
      .getSearch(_var)
      .subscribe((_variedad: any) => {

        this._length = _variedad.pagination.total_count;
        _variedad.data.map((_element: any) => {
          this.cardContentList.push({
            card_id: _element.variety_id,
            card_id_1: null,
            card_name: _element.variety_name,
            card_id_2: _element.species_id,
            card_name_2: null,
            card_value_1: _element.synonyms,
            card_date: null,
            card_value_2: _element.public_observation_count,
            card_user_id: _element.user_id,
            card_username: _element.username,
            card_user_image_url: _element.user_image_url,
            card_image_url: _element.variety_image_url,
          });
        });
      });
  }

  // fnSearchVarietyNames(variety_value: string | null): string[] {
  //   const _optionList: string[] = [];
  //   const _var = {
  //     page: 0,
  //     page_size: 100,
  //     variety_name: variety_value,
  //     country: null,
  //     region: null,
  //     varietal_group: null,
  //     original_only: true,
  //     is_original: true,
  //     user_id: null,
  //     created_date: null,
  //   };
  //   this.variedadService
  //     .getSearch(_var)
  //     .subscribe((_variedad: RespSearch) => {
  //       _variedad.data.map((_element) => {
  //         _optionList.push(_element.variety_name);
  //       });
  //     });
  //   return _optionList;
  // }

  fnSearchVarietyNames(variety_value: string | null): string[] {
    const _optionList: string[] = [];

    const _var = {
      variety_name: variety_value,
      is_original: true,
      page: 0,
      page_size: 100,
    };

    this.variedadService.getVarietyNames(_var)
      .subscribe((_resp: any) => {
        _resp.data.map(
          (_element: string) => _optionList.push(_element));
      });

    return _optionList;
  }



  fnAdvanceSearchVariety(_var: {
    page: number | null;
    page_size: number | null;
    _filters: { filters: VarietyFilter[] };
  }) {
    if (_var._filters) {
      this.cardContentList = [];
      this.variedadService
        .postAdvancedFilters(_var)
        .subscribe((_variedad: RespSearch) => {
          this._length = _variedad.pagination.total_count;
          _variedad.data.map((_element: any) => {
            this.cardContentList.push({
              card_id: _element.variety_id,
              card_id_1: null,
              card_name: _element.variety_name,
              card_id_2: _element.species_id,
              card_name_2: null,
              card_value_1: _element.synonyms,
              card_date: null,
              card_value_2: null,
              card_user_id: _element.user_id,
              card_username: _element.username,
              card_user_image_url: _element.user_image_url,
              card_image_url: _element.variety_image_url,
            });
          });
        });
    }
  }

  fnGoAdvanceFilter() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/catalogo-search"]).then(() => {
      })
    })
  }

  fnClearFilters() {
    this.variedadService.clearFilters();
    this.matBadgeVarietyFilters = null;
    this.variety_control.setValue(null);
    this.country_control.setValue(null);
    this.region_control.setValue(null);
    this.varietal_group_control.setValue(null);
    this.user_control.setValue(null)
    this.fnSearchVariety();
  }

  fnVarietyCount() {
    this.observationVarietyCounts = this.observationService.getCounts();
  }

  displayFnUser(_obj: any): string {
    return _obj && _obj.username ? _obj.username : '';
  }

  fnGoToObservationView() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/observaciones"]).then(() => {
      })
    })
  }
}
